import React, { FunctionComponent } from "react";
import { DropdownIcon, UserPhotoUpload } from "../../assets/Icons";
import { TextField } from "@material-ui/core";
import IRecipientDetailsProps from "./Recipient";

export const StepOne: FunctionComponent<IRecipientDetailsProps.StepOneProps> = ({
  name,
  setName,
  category,
  setIsModalOpen,
}) => {
  return (
    <div className="flex justify-center space-x-16">
      {/* <UserPhotoUpload /> */}
      <div className="space-y-7">
        <TextField
          className="w-[400px]"
          variant="outlined"
          name="username"
          label="Name"
          required={true}
          onChange={(e) => setName(e.target.value)}
          value={name}
          inputProps={{ pattern: "[a-zA-Z0-9 ]{1,}" }}
        />

        <div
          id="relationship"
          onClick={() => setIsModalOpen("category")}
          className="h-[58px] w-[400px] bg-white border flex items-center border-gray-400 rounded-md p-4 text-[14px] justify-between cursor-pointer recepient-category"
        >
          <div>{category ? `${category}` : "Category*"}</div>
          <div>
            <DropdownIcon />
          </div>
        </div>
      </div>
    </div>
  );
};
